export const eventFrequencyDataset = [
    {frequency: "Monthly", tier: "high", freqNbr: "450"},
    {frequency: "Monthly", tier: "mid", freqNbr: "350"},
    {frequency: "Monthly", tier: "low", freqNbr: "300"},
    {frequency: "Quarterly", tier: "high", freqNbr: "275"},
    {frequency: "Quarterly", tier: "mid", freqNbr: "250"},
    {frequency: "Quarterly", tier: "low", freqNbr: "200"},
    {frequency: "SemiAnnual", tier: "high", freqNbr: "180"},
    {frequency: "SemiAnnual", tier: "mid", freqNbr: "160"},
    {frequency: "SemiAnnual", tier: "low", freqNbr: "140"},
    {frequency: "Yearly", tier: "high", freqNbr: "130"},
    {frequency: "Yearly", tier: "mid", freqNbr: "120"},
    {frequency: "Yearly", tier: "low", freqNbr: "100"},
    {frequency: "Biennial", tier: "high", freqNbr: "80"},
    {frequency: "Biennial", tier: "mid", freqNbr: "72" },
    {frequency: "Biennial", tier: "low", freqNbr: "75" },
    {frequency: "Every3rdYear", tier: "high", freqNbr: "55"},
    {frequency: "Every3rdYear", tier: "mid", freqNbr: "48"},
    {frequency: "Every3rdYear", tier: "low", freqNbr: "45"},
    {frequency: "Every4thYear", tier: "high", freqNbr: "40"},
    {frequency: "Every4thYear", tier: "mid", freqNbr: "35"},
    {frequency: "Every4thYear", tier: "low", freqNbr: "30"},
    {frequency: "Force", tier: "none", freqNbr: "force", }
]
export default eventFrequencyDataset;
